import { Button } from "@/components/ui/button";
import { NavLink } from "@/components/NavLink";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { ChevronDown } from "lucide-react";
import thinkrLogo from "@/assets/thinkr-logo.png";

interface HeaderProps {
  transparent?: boolean;
}

const Header = ({ transparent = false }: HeaderProps) => {
  return (
    <header className={`w-full ${transparent ? 'absolute top-0 left-0 right-0 z-50 border-transparent' : 'border-b border-border bg-background'}`}>
      <div className="mx-auto max-w-7xl px-6 py-4">
        <div className="flex items-center justify-between">
          <NavLink to="/" className="flex items-center">
            <img src={thinkrLogo} alt="thinkr" className={`h-6 md:h-7 ${transparent ? 'brightness-0 invert' : ''}`} />
          </NavLink>

          <nav className="hidden md:flex items-center gap-8">
            <NavLink
              to="/product"
              className={`text-sm transition-colors ${transparent ? 'text-white/80 hover:text-white' : 'text-muted-foreground hover:text-foreground'}`}
            >
              Product
            </NavLink>
            
            <DropdownMenu>
              <DropdownMenuTrigger className={`flex items-center gap-1 text-sm transition-colors focus:outline-none ${transparent ? 'text-white/80 hover:text-white' : 'text-muted-foreground hover:text-foreground'}`}>
                Solutions
                <ChevronDown size={14} />
              </DropdownMenuTrigger>
              <DropdownMenuContent align="start" className="bg-background border border-border">
                <DropdownMenuItem asChild>
                  <NavLink to="/solutions/agencies" className="w-full cursor-pointer">
                    Agencies
                  </NavLink>
                </DropdownMenuItem>
                <DropdownMenuItem asChild>
                  <NavLink to="/solutions/small-businesses" className="w-full cursor-pointer">
                    Small Businesses
                  </NavLink>
                </DropdownMenuItem>
                <DropdownMenuItem asChild>
                  <NavLink to="/solutions/dtc-brands" className="w-full cursor-pointer">
                    DTC Brands
                  </NavLink>
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>

            <NavLink
              to="/pricing"
              className={`text-sm transition-colors ${transparent ? 'text-white/80 hover:text-white' : 'text-muted-foreground hover:text-foreground'}`}
            >
              Pricing
            </NavLink>
            <NavLink
              to="/contact"
              className={`text-sm transition-colors ${transparent ? 'text-white/80 hover:text-white' : 'text-muted-foreground hover:text-foreground'}`}
            >
              Contact
            </NavLink>
            <a
              href="https://www.thinkr.studio/"
              className={`text-sm transition-colors ${transparent ? 'text-white/80 hover:text-white' : 'text-muted-foreground hover:text-foreground'}`}
            >
              Login
            </a>
          </nav>

          <Button 
            variant="default" 
            size="sm" 
            className="rounded-md bg-blue-600 hover:bg-blue-700"
            asChild
          >
            <a href="https://www.thinkr.studio/">Try it now.</a>
          </Button>
        </div>
      </div>
    </header>
  );
};

export default Header;
